module.exports = __webpack_public_path__ + "static/media/icon.1bc997db.png";